import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaPrint, FaDownload, FaEnvelope } from 'react-icons/fa';
import './InvoiceDetails.css';

const StatementsDetail = () => {
  const { invoiceNumber } = useParams();
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate fetching invoice data from API/state
    const fetchInvoiceDetails = () => {
      // This data would normally come from your backend or global state
      const invoicesData = {
        'INV00176': {
          invoiceNumber: 'INV00176',
          orderNumber: 'HT00176',
          date: '2026-03-02',
          customer: 'Hira dental lab UK',
          status: 'Pending',
          total: 29.95,
          paymentDue: 29.95,
          items: [
            {
              name: 'OPEN SOURCE INTERNAL ANALOGUE - Compatible with Osstem® GS(TS) Regular/Ultra-Wide Implant Level',
              sku: '2902-31-40',
              quantity: 1,
              pricePerUnit: 9.95,
              totalPrice: 9.95
            },
            {
              name: 'OPEN SOURCE INTERNAL TI BASE ENGAGING - Compatible with OSSTEM® GS(TS) Regular/Ultra-Wide [GH3-CH6]',
              sku: '2902-51-36',
              quantity: 1,
              pricePerUnit: 29.95,
              totalPrice: 29.95
            }
          ],
          trackingId: 'HT00067',
          orderStatus: 'Order Placed',
          placementDate: '2026-01-06',
          deliveryDate: '2026-01-06T10:52:46Z',
          agent: 'Muddas Rashid',
          agentPhone: '+447581550310',
          discount: 0.00,
          deliveryCharges: 0.00,
          vat: 0.00
        },
        'INV00177': {
          invoiceNumber: 'INV00177',
          orderNumber: 'HT00177',
          date: '2026-03-02',
          customer: 'Hira dental lab UK',
          status: 'Pending',
          total: 84.90,
          paymentDue: 84.90,
          items: [
            {
              name: 'Dental Implant Kit',
              sku: 'IMP-001',
              quantity: 2,
              pricePerUnit: 42.45,
              totalPrice: 84.90
            }
          ],
          trackingId: 'HT00177',
          orderStatus: 'Processing',
          placementDate: '2026-03-02',
          deliveryDate: '2026-03-05T10:00:00Z',
          agent: 'Muddas Rashid',
          agentPhone: '+447581550310',
          discount: 0.00,
          deliveryCharges: 0.00,
          vat: 0.00
        }
        // Add more invoices as needed
      };

      setInvoice(invoicesData[invoiceNumber] || invoicesData['INV00176']);
      setLoading(false);
    };

    fetchInvoiceDetails();
  }, [invoiceNumber]);

  const handlePrint = () => {
    window.print();
  };

  const handleDownload = () => {
    // Implement PDF download functionality
    alert('Downloading invoice...');
  };

  const handleEmail = () => {
    // Implement email functionality
    alert('Sending invoice via email...');
  };

  if (loading) {
    return <div className="loading">Loading invoice details...</div>;
  }

  if (!invoice) {
    return <div className="error">Invoice not found</div>;
  }

  return (
<>       {/* Header with back button */}
        <div className="invoice-header-actions">
          <button className="back-button" onClick={() => navigate(-1)}>
           Back to Statements
          </button>
          <div className="invoice-actions">
            <button className="action-btn" onClick={handlePrint}>
              <FaPrint /> Print
            </button>
            <button className="action-btn" onClick={handleDownload}>
              <FaDownload /> Download
            </button>
            <button className="action-btn" onClick={handleEmail}>
              <FaEnvelope /> Email
            </button>
          </div>
        </div>

        {/* Invoice Card */}
        <div className="invoice-card">
          {/* Invoice Header */}
          <div className="invoice-header">
            <div className="invoice-title-section">
              <h1>INVOICE</h1>
              <div className="invoice-number">#{invoice.invoiceNumber}</div>
            </div>
            <div className="invoice-status">
              <span className={`status-badge ${invoice.status.toLowerCase()}`}>
                {invoice.status}
              </span>
            </div>
          </div>

          {/* Customer Info */}
          <div className="customer-info-section">
            <div className="info-group">
              <label>Customer:</label>
              <p>{invoice.customer}</p>
            </div>
            <div className="info-group">
              <label>Order Number:</label>
              <p>{invoice.orderNumber}</p>
            </div>
            <div className="info-group">
              <label>Invoice Date:</label>
              <p>{invoice.date}</p>
            </div>
          </div>

          {/* Order Details */}
          <div className="order-details-section">
            <h3>Order Details</h3>
            <div className="details-grid">
              <div className="detail-item">
                <label>Tracking ID:</label>
                <span>{invoice.trackingId}</span>
              </div>
              <div className="detail-item">
                <label>Order Status:</label>
                <span>{invoice.orderStatus}</span>
              </div>
              <div className="detail-item">
                <label>Placement Date:</label>
                <span>{invoice.placementDate}</span>
              </div>
              <div className="detail-item">
                <label>Delivery Date:</label>
                <span>{new Date(invoice.deliveryDate).toLocaleString()}</span>
              </div>
              <div className="detail-item">
                <label>Agent:</label>
                <span>{invoice.agent}</span>
              </div>
              <div className="detail-item">
                <label>Agent Phone:</label>
                <span>{invoice.agentPhone}</span>
              </div>
            </div>
          </div>

          {/* Products Table */}
          <div className="products-section">
            <h3>Ordered Products</h3>
            <table className="products-table">
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>SKU</th>
                  <th>Quantity</th>
                  <th>Price per unit</th>
                  <th>Total Price</th>
                </tr>
              </thead>
              <tbody>
                {invoice.items.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.sku}</td>
                    <td>{item.quantity}</td>
                    <td>£{item.pricePerUnit.toFixed(2)}</td>
                    <td>£{item.totalPrice.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Amount Summary */}
          <div className="amount-summary">
            <div className="summary-row">
              <span>Total:</span>
              <span>£{invoice.total.toFixed(2)}</span>
            </div>
            <div className="summary-row">
              <span>Discount:</span>
              <span>£{invoice.discount.toFixed(2)}</span>
            </div>
            <div className="summary-row">
              <span>Delivery Charges:</span>
              <span>£{invoice.deliveryCharges.toFixed(2)}</span>
            </div>
            <div className="summary-row">
              <span>VAT:</span>
              <span>£{invoice.vat.toFixed(2)}</span>
            </div>
            <div className="summary-row grand-total">
              <span>Grand Total:</span>
              <span>£{invoice.total.toFixed(2)}</span>
            </div>
            <div className="summary-row payment-due">
              <span>Payment Due:</span>
              <span>£{invoice.paymentDue.toFixed(2)}</span>
            </div>
          </div>

          {/* Payment Status */}
          <div className="payment-status">
            <div className="status-indicator pending">
              [Pending]
            </div>
          </div>
        </div>
      </> 
  );
};

export default StatementsDetail;